import { Controller } from "@hotwired/stimulus"
import confetti from "canvas-confetti"

const CONFETTI_COLORS = ["#059669", "#0284c7", "#d97706", "#7c3aed", "#e11d48"]

const celebratedCalls = new Set()

export default class extends Controller {
  static targets = ["check", "heading", "count", "confetti"]
  static values = { callId: Number, milestone: Boolean, counted: Boolean }

  connect() {
    this.animations = []
    this.headingTarget.focus({ preventScroll: true })

    if (celebratedCalls.has(this.callIdValue)) return
    celebratedCalls.add(this.callIdValue)
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    this.animations.push(this.checkTarget.animate(
      [{ transform: "scale(0.85)", opacity: 0 }, { transform: "scale(1)", opacity: 1 }],
      { duration: 240, easing: "ease-out" }
    ))

    if (this.countedValue) this.tickCount()
    if (this.milestoneValue) this.celebrate()
  }

  disconnect() {
    clearTimeout(this.countdown)
    this.animations.forEach(animation => animation.cancel())
    this.confetti?.reset()
  }

  tickCount() {
    const count = Number(this.countTarget.textContent)
    if (count > 1) this.countTarget.textContent = count - 1

    const animation = this.countTarget.animate(
      [{ transform: "scale(1)" }, { transform: "scale(1.35)", color: "#047857" }, { transform: "scale(1)" }],
      { duration: 420, delay: 200, easing: "ease-out" }
    )
    this.animations.push(animation)
    this.countdown = setTimeout(() => { this.countTarget.textContent = count }, 320)
  }

  celebrate() {
    this.confetti = confetti.create(this.confettiTarget, { resize: true })
    const burst = { particleCount: 70, spread: 60, startVelocity: 50, ticks: 220, scalar: 0.9, colors: CONFETTI_COLORS }

    this.confetti({ ...burst, angle: 60, origin: { x: 0, y: 0.85 } })
    this.confetti({ ...burst, angle: 120, origin: { x: 1, y: 0.85 } })
  }
}
